module.exports = __webpack_public_path__ + "static/img/top-img.2e2323e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/top-img.png
// module id = 3uTF
// module chunks = 52